//Globals
// moment.locale("pt-br");

if (window.location.host.includes("homolog")) {
    var domainName = "homolog.inf.br";
} else if (window.location.host.includes("localhost")) {
    var domainName = "";
} else {
    var domainName = "cartacapital.com.br";
}

var urlsso = document.getElementById("sso").value;
var urlproject = document.getElementById("urlproject").value;
var date = new Date();
var maxage = date.setTime(+date + 30 * 86400000);

var ssoHeaders = new Headers();
ssoHeaders.append("Content-Type", "application/json");
ssoHeaders.append("freeroute", true);

/**
 * Validações de paginas e lista de funções
 */
let thisUrlpage = window.location.pathname.split("/");
let filteredPage = thisUrlpage.filter(Boolean);

let slugPage = filteredPage[filteredPage.length - 1];
document.cookie =
    "sso_singleslug=" +
    slugPage +
    "; expires=" +
    date.toUTCString() +
    "; path=/; domain=." +
    domainName;

var htmlloading =
    '<div class="loading">\
                           <span class="msg">\
                                 <i class="load"></i>\
                                 Processando ...\
                           </span>\
                        </span>';

if (getCookie("sso_auth_token") == null) {
    if (document.querySelector(".loadcoments")) {
        var formComment = `<div class="c-comments">\
                           <div class="c-comments__container">\
                              <div class="c-comments__left">\
                                 <p>Para proteger e incentivar discussões produtivas, os comentários são exclusivos para usuários cadastrados junto a CartaCapital.</p>\
                                 <span>Já tem acesso? <a href="/acesso/?utm_source=cartacapital.com.br&utm_medium=comentario&utm_content='${slugPage}'">Faça login</a></span>\
                              </div>\
                              <div class="c-comments__right">\                                
                                <span>
                                    Seja assinante! Aproveite conteúdos exclusivos e tenha acesso total ao site.
                                </span>\
                                 <a href="https://www.assinecarta.com.br/?utm_source=cartacapital.com.br&utm_medium=comentario&utm_content='${slugPage}" onclick="signComments()" target="_blank">${
            ctaRight || "Assine CartaCapital"
        }</a>\
                                <span>ou</span>
                                <a href="/cadastro/?utm_source=cartacapital.com.br&utm_medium=comentario&utm_content='${slugPage}'" style="background-color: #000">Cadastre-se gratuitamente!</a></span>

                              </div>\
                           </div>\
                        </div>\
                        <span>Os comentários não representam a opinião da revista. A responsabilidade é do autor da mensagem.</span>`;
    }
} else {
    var formComment =
        '<section class="e-comments formcomment">\
                              <h2>Deixe seu comentário</h2>\
                              <form action="" id="form" class="e-comments__form " onsubmit="return false;">\
                                 <label for="nome">\
                                    <textarea name="comment" id="comment" rows="10"></textarea>\
                                 </label>\
                                 <button type="submit" onclick="ssoCommentSend(); createComment()">Enviar comentário</button>\
                              </form>\
                           </section>';
}

function setPaywallUser(type) {
    let defaultType = "hard";
    if (type == "soft") {
        defaultType = "soft";
    }
    document.cookie =
        "ssotype=" +
        defaultType +
        "; expires=" +
        date.toUTCString() +
        "; path=/; domain=." +
        domainName;
    window.location.href = "/cadastro";
    return false;
}
/**
 * Consulta se o token esta ativo
 */
function verifyUser() {
    let requestOptions = {
        method: "GET",
        headers: ssoHeaders,
    };
    if (getCookie("sso_auth_token")) {
        fetch(urlsso + "/tokens/" + getCookie("sso_auth_token") + "/validate", requestOptions )
        .then((res) => {
            data = res.json();
            if (res.status == 401) {
                eraseCookie("sso_auth_token", domainName);
                eraseCookie("ssoname", domainName);
                eraseCookie("ssoassinante", domainName);
                localStorage.removeItem("sso_auth_token");

                $("body").append(htmlloading);

                $(".loading .msg").html('<i class="none"></i> Sessão expirada.');

                setTimeout(() => {
                    window.location.href = "/login";
                }, 2000);
            }
            return data;
        })
        .then((data) => {
            if (data.validate == false) {
                console.log("sair");
                eraseCookie("sso_auth_token", domainName);
                eraseCookie("ssoname", domainName);
                eraseCookie("ssoassinante", domainName);
                localStorage.removeItem("sso_auth_token");

                $(".savebookmark").hide();
                $(".header__left").append(`<a href="/newsletters-abertas" class="desktop-only" title="Newsletters">Newsletters</a>`);
                $(".ftAssinante").append(`<a href="/newsletters-abertas" class="desktop-only" title="Newsletters">Newsletters</a>`);

                if ($(".listarevista").length > 0) {
                    $(".listarevista").attr("href", "/acesso");
                    //$('.listarevista').attr('onclick','return false');
                }
                $("body").append('<input type="hidden" name="php-isul" id="php-isul" value="0" />');

                let intervalGTag = setInterval(() => {
                    if ( typeof gtag !== 'function' ) return;
                    clearInterval(intervalGTag);
                    gtag('set', 'user_properties', {
                        'user_code': 'null',
                        'user_logged': 'false',
                        'user_type': 'visitante',
                        'user_newsletter': 'false'
                    });
                }, 100);
            } else {
                eraseCookie('user_porosity', domainName);
                validateRdStationUser(data.subscriber, data.rdExists);
                
                $(".savebookmark").show();

                localStorage.setItem("sso_auth_token", getCookie("sso_auth_token"));
                if (getCookie("ssoassinante") == "true") {
                    $(".header__sign").remove();
                    $(".footer__sign").remove();

                    if ( document.querySelector("body").getElementsByClassName("typehard").length > 0 ) {
                        $("body").append(
                            '<input type="hidden" name="php-isul" id="php-isul" value="1" />'
                        );
                    }
                    if ($(".p-blocked").length) {
                        $(".p-blocked").remove();
                    }
                } else {
                    if ( document.querySelector("body").getElementsByClassName("typehard").length > 0 ) {
                        $("body").append('<input type="hidden" name="php-isul" id="php-isul" value="0" />');
                    }

                    if ($(".paywall").length) {
                        $(".paywall .paywall__assinante").css({
                            display: "none",
                        });
                    }

                    if ($(".listarevista").length > 0) {
                        $(".listarevista").attr("href", "/acesso");
                        //$('.listarevista').attr('onclick','return false');
                    }
                    if ($(".p-content").length) {
                        $(".p-content").remove();
                    }
                }

                if (data.subscriber != undefined) {
                    if (getCookie("ssoassinante") != data.subscriber) {
                        eraseCookie("ssoassinante", domainName);
                        document.cookie = "ssoassinante=" + data.subscriber + "; expires=" + localStorage.getItem("timecookie") + "; path=/; domain=" + domainName;
                    }
                }
                if (data.product != undefined) {
                    if (getCookie("sso_product") != data.product) {
                        eraseCookie("sso_product", domainName);
                        document.cookie = "sso_product=" + data.product + "; expires=" + localStorage.getItem("timecookie") +"; path=/; domain=" + domainName;
                    }
                }

                var newhtml = `<a href="/minha-conta" title="Minha Conta">
                            Minha Conta
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 22c-3.123 0-5.914-1.441-7.749-3.69.259-.588.783-.995 1.867-1.246 2.244-.518 4.459-.981 3.393-2.945-3.155-5.82-.899-9.119 2.489-9.119 3.322 0 5.634 3.177 2.489 9.119-1.035 1.952 1.1 2.416 3.393 2.945 1.082.25 1.61.655 1.871 1.241-1.836 2.253-4.628 3.695-7.753 3.695z"/>
                            </svg>
                        </a>`;

                var newHtmlNewsletter = `<nav class="menu__item menu__item--newsletter">
                                        <div class="menu__heading">
                                            <a href="/minha-conta#newsletter" title="Newsletters">Newsletters</a>
                                        </div>
                                    </nav>`;
                // <a href="#" title="Sair" onclick="ssoLogout();">Sair</a>

                $(newhtml).insertAfter(".header__menu .login");
                $(newhtml).insertAfter(".menu__top .login");
                $(newHtmlNewsletter).insertAfter(".menu__item:last-of-type");

                $(".header__left").append(`<a href="/minha-conta#salvas" class="desktop-only" title="Salvas">Salvas</a>
                                    <!--<a href="/minha-conta#newsletter" class="desktop-only" title="Newsletters">Newsletters</a>-->`);
                $(".ftAssinante").append(`<a href="/minha-conta#newsletter" class="desktop-only" title="Newsletters">Newsletters</a>`);

                if (window.innerWidth < 800) {
                    if (
                        getCookie("ssoassinante") != "" &&
                        ((getCookie("sso_product") != null &&
                            getCookie("sso_product") == "CADASTRADO") ||
                            getCookie("sso_product") == null)
                    ) {
                        $('.header__menu a[title="Minha Conta"]').remove();
                    }
                }

                $(".header__menu .login").remove();
                $(".menu__top .login").remove();

                let intervalGTag = setInterval(() => {
                    if ( typeof gtag !== 'function' ) return;
                    clearInterval(intervalGTag);
                    gtag('set', 'user_properties', {
                        'user_code': getCookie('sso_reader'),
                        'user_logged': 'true',
                        'user_type': data.subscriber ? 'assinante' : 'cadastrado',
                        'user_newsletter': data.rdExists ? 'true' : 'false'
                    });
                }, 100);

                welcomeModal();
            }
        })
        .catch((error) => console.log("error", error));
    } else {
        console.log("sair");
        eraseCookie("sso_auth_token", domainName);
        eraseCookie("ssoname", domainName);
        eraseCookie("ssoassinante", domainName);
        localStorage.removeItem("sso_auth_token");

        $(".savebookmark").hide();
        $(".header__left").append(`<a href="/newsletters-abertas" class="desktop-only" title="Newsletters">Newsletters</a>`);
        $(".ftAssinante ").append(`<a href="/newsletters-abertas" class="desktop-only" title="Newsletters">Newsletters</a>`);

        if ($(".listarevista").length > 0) {
            $(".listarevista").attr("href", "/acesso");
            //$('.listarevista').attr('onclick','return false');
        }
        $("body").append('<input type="hidden" name="php-isul" id="php-isul" value="0" />');

        let intervalGTag = setInterval(() => {
            if ( typeof gtag !== 'function' ) return;
            clearInterval(intervalGTag);
            gtag('set', 'user_properties', {
                'user_code': 'null',
                'user_logged': 'false',
                'user_type': 'visitante',
                'user_newsletter': 'false'
            });
        }, 100);
    }
    return false;
}

function welcomeModal() {
    if (localStorage.getItem("welcome")) {
        if (!localStorage.getItem("welcome") == "true") return;
        localStorage.removeItem("welcome");

        let welcomeHTML = `<div class="welcome-modal">
                           <div class="welcome-modal__content">
                              <button type="button" title="Fechar modal" class="welcome-modal__close">&times;</button>
                              <div class="welcome-modal__text"> 
                                 <h2>Obrigado por se cadastrar na CartaCapital!</h2>
                                 <p>Aproveite nossos conteúdos de qualidade e fique por dentro das notícias mais relevantes. Para ter acesso a mais conteúdos exclusivos, comentários e muito mais, assine agora mesmo clicando <a href="https://www.assinecarta.com.br/?utm_source=cartacapital.com.br&utm_medium=modalCadastro&utm_content=${slugPage}" target="_blank" title="Assine">aqui</a>. Não perca a oportunidade de se manter informado e fazer parte da nossa comunidade!</p>
                                 <a href="https://www.assinecarta.com.br/?utm_source=cartacapital.com.br&utm_medium=modalCadastro&utm_content=${slugPage}" target="_blank" title="Assine" class="btn btn--primary">Assine já</a>
                              </div>
                           </div>
                        </div>`;

        $("body").append(welcomeHTML);
        $(".welcome-modal__close").click(function () {
            $(".welcome-modal").fadeOut();
        });
    }
}

/**Retorna os dados do usuário
 * @param token
 */
function userData() {
    let requestOptions = {
        method: "GET",
        headers: ssoHeaders,
    };
    fetch(
        urlsso + "/readers/tokens/" + getCookie("sso_auth_token"),
        requestOptions
    )
        .then((response) => response.json())
        .then((data) => {
            if (typeof data.name !== "undefined") {
                document.cookie =
                    "ssoname=" +
                    data.name +
                    "; expires=" +
                    date.toUTCString() +
                    "; path=/; domain=." +
                    domainName;
                ssoElasticLogin();
                //window.location.href = "/";

                if (
                    document.referrer.includes(urlproject) &&
                    !document.referrer.includes("esqueci-minha-senha")
                ) {
                    window.location.href = document.referrer;
                    if (document.referrer.includes("acesso")) {
                        if (window.history.length >= 2) {
                            history.go(-2);
                        } else {
                            window.location.href = urlproject;
                        }
                    } else {
                        let prevPage = document.referrer;
                        if (prevPage.includes("/amp")) {
                            prevPage = prevPage.replace("/amp", "");
                        }
                        window.location.href = prevPage;
                    }
                } else {
                    window.location.href = urlproject;
                }
            }
        })
        .catch((error) => console.log("error", error));
    return false;
}

/**Retorna os dados do usuário para o formulário da pagina minha conta
 * @param token
 */
function ssouserData() {
    let requestOptions = {
        method: "GET",
        headers: ssoHeaders,
    };

    fetch(
        urlsso + "/readers/tokens/" + getCookie("sso_auth_token"),
        requestOptions
    )
        .then((response) => response.json())
        .then((data) => {
            console.log(data);
            let birthdate = new Date(data.birthdate).toLocaleDateString('pt-BR');
            document.querySelector('[name="name"]').value = data.name;
            // Coloca o nome na saudação também
            document.querySelector(".m-painel__name").innerHTML = data.name;
            document.querySelector('[name="gender"]').value = data.gender;
            new dgCidadesEstados({
                cidade: document.querySelector('[name="city"]'),
                estado: document.querySelector('[name="state"]'),
                estadoVal: data.state,
                cidadeVal: data.city,
            });
            document.querySelector('[name="country"]').value = data.country;
            document.querySelector('[name="profession"]').value =
                data.profession;
            document.querySelector('[name="mobilephone"]').value =
                data.mobilephone;
            document.querySelector('[name="birthdate"]').value = birthdate;

            if (data.preference == true) {
                document.querySelector('[name="preference"]').checked = true;
            }

            if ( document.querySelector('.mask-Phone') ) {
                $(".mask-Phone").mask("(00) 0000-00009");
            }
            $(".mask-Phone").blur(function (event) {
                if ($(this).val().length == 19) {
                    // Celular com 9 dígitos + 2 dígitos DDD e 4 da máscara
                    if ( document.querySelector('.mask-Phone') ) {
                        $(".mask-Phone").mask("(00) 00000-0009");
                    }
                } else {
                    if ( document.querySelector('.mask-Phone') ) {
                        $(".mask-Phone").mask("(00) 0000-00009");
                    }
                }
            });

            if (getCookie("sso_origin") == "google") {
                $(".a-email").hide();
                $(".a-pass").hide();
            }
        })
        .catch((error) => console.log("error", error));
    return false;
}

//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------


//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

//Valida ações das internas de post
setTimeout(() => {
    verifyUser();
    let body = document.querySelector("body");

    if (body.getElementsByClassName("ssopopular").length > 0) {
        let typePopular = $(".ssopopular").data("type");
        ssoRank(typePopular);
    }

    if (body.getElementsByClassName("ssopopular--single").length > 0) {
        let typePopular = $(".ssopopular--single").data("type");
        ssoRankRelated(typePopular);
    }

    if (body.getElementsByClassName("single-post").length > 0) {
        $(".s-content__bookmark").hide();

        let typePopular = $("body").hasClass("single-podcastscpt")
            ? "podcast"
            : "";
        let urlParams = new URLSearchParams(window.location.search);

        let noTracking = document.querySelector('#no_track') ? true : false;
        if (!noTracking) {
            ssoRankSingle(typePopular);
        }
        ssoComments();

        if (
            getCookie("sso_auth_token") !== null ||
            urlParams.has("signature")
        ) {
            ssoSingle();
        }

        if (getCookie("sso_auth_token") !== null) {
            $(".s-content__bookmark").show();
            ssoElastic();
            if ( body.getElementsByClassName("paywall").length > 0 || body.getElementsByClassName("s-freemium").length > 0 ) {
                // if ( body.getElementsByClassName("paywall").length > 0 ) {
                    if ( $(".paywall__top>a") ) {
                        $(".paywall__top>a").hide();
                    }
                    setTimeout(() => {
                        $("body").addClass("hide");
                        console.log("02");
                    }, 150);
                // }
                
            }

            ssoConsultBookmark();
            function createComment() {
                if ( typeof gtag == "function" ) {
                    gtag("event", "comment added", {
                        event_category: "NTG user",
                        event_label: window.location.pathname,
                        non_interaction: false,
                    });
                }
            }
        } else {
            setTimeout(function () {
                if ($(".paywall").length > 0) {
                    if ( typeof gtag == "function" ) {
                        gtag("event", "paywall modal impression 1", {
                            event_category: "NTG paywall",
                            event_label: window.location.pathname,
                            non_interaction: true,
                        });
                    }
                }
                if ($(".s-freemium").length > 0) {
                    if ( typeof gtag == "function" ) {
                        gtag("event", "paywall modal impression 2", {
                            event_category: "NTG paywall",
                            event_label: window.location.pathname,
                            non_interaction: true,
                        });
                    }
                }
            }, 5000);

            if (body.getElementsByClassName("paywall").length > 0 || body.getElementsByClassName("s-freemium").length > 0) {
                setTimeout(() => {
                    $("body").addClass("hide");
                    console.log("02");
                }, 150);
            }
        }

        if (
            getCookie("ssoassinante") != "" &&
            ((getCookie("sso_product") != null &&
                getCookie("sso_product") == "CADASTRADO") ||
                getCookie("sso_product") == null)
        ) {
            if ($(".listacomments h2").length) {
                $(formComment).insertAfter(".listacomments h2");
            } else {
                $(formComment).insertBefore(".loadcoments");
            }
        } else {
            $(formComment).insertBefore(".loadcoments");
        }
    } else if ($("body").hasClass("category") == true) {
        $(".s-content__bookmark").hide();
        if (getCookie("sso_auth_token") !== null) {
            $(".s-content__bookmark").show();
            ssoConsultBookmark();
        }
    } else {
        //Fica validando se o usuario esta logado
        ssoPage(slugPage);
        ssoListNewsletters(slugPage);
    }

    if (localStorage.getItem("sso_confirmed") == "true") {
        confirmEmail();
    }

    $("body").removeClass("hide");
}, 500);

/**Valida slug interna
 * @param token
 * @param slug
 */
function ssoSingle() {
    let urlParams = new URLSearchParams(window.location.search);
    let thisUrl = window.location.pathname.split("/");
    let filtered = thisUrl.filter(Boolean);
    let slug = filtered[filtered.length - 1];
    let hasSignature = urlParams.has("signature");

    let requestOptions = {
        method: hasSignature ? "POST" : "GET",
        headers: ssoHeaders,
        body: hasSignature
            ? JSON.stringify({
                  signature: urlParams.get("signature"),
                  slug,
              })
            : null,
    };

    const urlssov2 = urlsso.replace("v1", "v2");

    const request = hasSignature
        ? urlssov2 + "/pages/authorization/"
        : urlsso + "/pages/auth/" + getCookie("sso_auth_token") + "/" + slug;

    fetch(request, requestOptions)
        .then((response) => response.json())
        .then((data) => {
            if (data.authorization) {
                if (document.querySelector(".maggazine-add")) {
                    let timeoutMaggazine = setInterval(() => {
                        if (typeof loadMaggazineAdd != "function") return;
                        clearInterval(timeoutMaggazine);
                        loadMaggazineAdd();
                    }, 300);
                }

                if ( document.querySelector(".contentSoft") ) {
                    document.querySelector(".contentSoft").style.height = "100%";
                }
                if ( document.querySelector(".contentExlusive") ) {
                    document.querySelector(".contentExlusive").style.height = "100%";
                }
                if ( document.querySelector(".s-content__text > .contentSoft + p" ) ) {
                    document.querySelector(".s-content__text > .contentSoft + p").style.display = "block";
                }
                $(".paywall").remove();
                $(".s-freemium").remove();
                $(".s-exclusive").remove();
                $(".s-freemium__sign").remove();
                $("body").removeClass("hide");

                $(".s-content__text>.contentSoft>p:nth-of-type(2) ~ *").css("display", "");
                $(".s-content__text>.contentSoft+p").css("display", "");
                $('main').css('max-height', '');
                $('body').removeClass('hide')

                if ( document.querySelector(".contentsingle").dataset.type != "open" ) {
                    let audiomeHTML = `<div id="audiome-container"></div>
                    <script>!function(){let e=document.createElement("script");e.src="https://readme.ai/static/widget/cartacapital.js",document.body.appendChild(e)}();</script>`;

                    $(".contentsingle").prepend(audiomeHTML);
                }

                if ( $(".s-content__text.contentsingle").attr("data-type") == "hard" && !hasSignature ) {
                    linkPresenteSingle();
                }

                if (hasSignature) {
                    window.addEventListener("scroll", function () {
                        var scrollPosition =
                            window.pageYOffset ||
                            document.documentElement.scrollTop ||
                            document.body.scrollTop;

                        var tagElement = $(".s-content__text")[0];

                        var rect = tagElement.getBoundingClientRect();
                        var tagHeight = tagElement.offsetHeight;

                        if (scrollPosition > rect.top + tagHeight * 0.5) {
                            modalLinkPresente();
                            window.removeEventListener(
                                "scroll",
                                arguments.callee
                            );
                        }
                    });
                }
            } else {
                setTimeout(function () {
                    $('.content-closed > p:not(:empty):nth-of-type(2) ~ *').remove();
                    
                    if ($(".paywall").length > 0) {
                        if ( typeof gtag == "function" ) {
                            gtag("event", "paywall modal impression 1", {
                                event_category: "NTG paywall",
                                event_label: window.location.pathname,
                                non_interaction: true,
                            });
                        }
                    }

                    if (hasSignature) {
                        $("body").removeClass("hide");
                        $("body").append(htmlloading);
                        const htmlModal = `<div class="modal-presente__window">
                                       <span>&times;</span>
                                       <p class="text-expired">${data.message}</p>        
                                       <button type="button" class="modal-presente__close close-expired">Entendi</button>   
                                    </div>`;

                        $("body").css({ overflow: "hidden" });

                        $(".loading").html(htmlModal);

                        $(".modal-presente__close, .modal-presente__window > span").on("click", function (ev) {
                            ev.preventDefault();
                            $(".loading").fadeOut();
                            $("body").css({ overflow: "unset" });
                        });                        
                    }
                }, 5000);
            }
        })
        .catch((error) => console.log("error", error));
    return false;
}

/**Valida páginas fechadas
 * @param token
 * @param slug
 */
function ssoPage(slugPage) {
    if (slugPage == "minha-conta" && getCookie("sso_auth_token") == null) {
        window.location.href = "/login";
    }

    if (
        (slugPage == "acesso" || slugPage == "cadastro") &&
        getCookie("sso_auth_token") != null
    ) {
        window.location.href = "/minha-conta";
    }

    setTimeout(() => {
        if (
            document.querySelector("body").getElementsByClassName("locked")
                .length > 0 &&
            slugPage == "minha-conta"
        ) {
            if (getCookie("sso_auth_token") == null) {
                let returnhtml =
                    "<i class='none'></i>Esse acesso é exclusivo para assinantes";
                $(".loading .msg").html(returnhtml);
                setTimeout(() => {
                    window.location.href = "/";
                }, 2000);
            } else {
                ssouserData();
                ssoGetBookmark();
                ssoGetLinkPresente();
                ssoListUserNewsletters();
                $(".loading").fadeOut();
            }
        } else {
            $(".loading").fadeOut();
        }
    }, 500);
}

function confirmEmail() {
    let htmlModal = `<div class="m-confirm">
                        <div class="m-confirm__modal">
                           <p>Você precisa confirmar seu e-mail para ter acesso completo.</p>
                           <button type="button" title="Confirmar E-mail">Confirmar E-mail</button>
                        </div>
                     </div>`;

    document.querySelector("body").style.overflow = "hidden";
    document.querySelector("body").insertAdjacentHTML("beforeend", htmlModal);

    document
        .querySelector(".m-confirm__modal button")
        .addEventListener("click", function () {
            let requestOptions = {
                method: "POST",
                headers: ssoHeaders,
                redirect: "follow",
            };

            fetch(
                `${urlsso}/accounts/confirmation/refresh/token/${getCookie(
                    "sso_auth_token"
                )}`,
                requestOptions
            )
                .then((response) => response.json())
                .then((result) => {
                    if (
                        result.message ==
                        "E-mail de confirmação enviado com sucesso!"
                    ) {
                        document.querySelector(
                            ".m-confirm__modal"
                        ).innerHTML = `<p>${result.message}</br>Clique no link do email para confirmar.</p>`;
                    }
                })
                .catch((error) => console.log("error", error));
        });
}

//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

/**Rota de gravação de single para o ranking
 * @param token
 * @param slug
 */
function ssoRankSingle(typePopular) {
    //$('body').append(htmlloading);
    let type = !!typePopular ? typePopular : "pages";

    setTimeout(() => {
        let requestOptions = {
            method: "POST",
            headers: ssoHeaders,
            body: JSON.stringify({
                category: document.querySelector('[name="category"]').value,
                open_or_close: document.querySelector('[name="paywall"]').value,
                title: document.querySelector('[name="title"]').value,
                link: window.location.pathname,
                post_ID: document.querySelector('[name="post_id"]').value,
                excerpt: document.querySelector('[name="excerpt"]').value,
                autores: document.querySelector('[name="autores"]').value,
                imagem_thumb: document.querySelector('[name="imagem_thumb"]')
                    .value,
            }),
        };

        fetch(urlsso + "/" + type + "/ranking/", requestOptions)
            .then((response) => response.json())
            .then((data) => {})
            .catch((error) => console.log("error", error));
        return false;
    }, 500);
}

function ssoRank(typePopular) {
    let requestOptions = {
        method: "GET",
        headers: ssoHeaders,
    };
    let limit = $(".ssopopular").data("limit");
    totalVideos = $(".h-videos__item").length;
    if (totalVideos !== undefined) {
        limit = limit - totalVideos;
    }

    let type = !!typePopular ? typePopular : "pages";

    fetch(urlsso + "/" + type + "/ranking?limit=" + limit, requestOptions)
        .then((response) => response.json())
        .then((data) => {
            if (data.length > 0) {
                var htmlmaislidos = "";
                data.forEach(function (ret) {
                    htmlmaislidos +=
                        '<a href="' +
                        ret.link +
                        '" title="' +
                        ret.title +
                        '" class="h-popular__item">\
                                    <h3>' +
                        ret.category +
                        "\
                                       " +
                        (ret.open_or_closed == "1"
                            ? '<span>\
                                          <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="https://www.w3.org/2000/svg">\
                                             <path d="M6 8.5V9.75V8.5ZM2.25 12.25H9.75C10.0815 12.25 10.3995 12.1183 10.6339 11.8839C10.8683 11.6495 11 11.3315 11 11V7.25C11 6.91848 10.8683 6.60054 10.6339 6.36612C10.3995 6.1317 10.0815 6 9.75 6H2.25C1.91848 6 1.60054 6.1317 1.36612 6.36612C1.1317 6.60054 1 6.91848 1 7.25V11C1 11.3315 1.1317 11.6495 1.36612 11.8839C1.60054 12.1183 1.91848 12.25 2.25 12.25ZM8.5 6V3.5C8.5 2.83696 8.23661 2.20107 7.76777 1.73223C7.29893 1.26339 6.66304 1 6 1C5.33696 1 4.70107 1.26339 4.23223 1.73223C3.76339 2.20107 3.5 2.83696 3.5 3.5V6H8.5Z" stroke="#0B0B0B" stroke-linecap="round" stroke-linejoin="round" />\
                                          </svg>\
                                       </span>'
                            : "") +
                        "\
                                    </h3>\
                                    <h2>" +
                        ret.title +
                        "</h2>\
                                    <p>" +
                        ret.excerpt +
                        "</p>\
                                 </a>";
                });
                $('.h-popular__item--squeleton').remove();
                $(".ssopopular").append(htmlmaislidos);
            }
        })
        .catch((error) => console.log("error", error));
    return false;
}

function ssoRankRelated() {
    // if (window.innerWidth < 800) return false;

    let requestOptions = {
        method: "GET",
        headers: ssoHeaders,
    };
    let limit = $(".ssopopular--single").data("limit") || 5;

    fetch(urlsso + "/pages/ranking?limit=" + limit, requestOptions)
        .then((response) => response.json())
        .then((data) => {
            if (data.length > 0) {
                var htmlmaislidos = "";

                let x = 1;
                
                data.forEach(function (ret) {
                    let thumb = "";
                    if (ret.imagem_thumb != "") {
                        thumb = `<figure class="s-related__image">
                        <img width="100" height="100" decoding="async" loading="lazy" src="${ret.imagem_thumb}" alt="">
                     </figure>`;
                    }

                    let number = '';
                    let author = '';

                    if ( !!document.querySelector('.category') ) {
                        number = x < 10 ? `<span>0${x}.</span>` : `<span>${x}.</span>`;
                        author = ret.autores ? `<span>Por <strong>${ret.autores}</strong></span>` : '';
                    }

                    htmlmaislidos += `<a href="${ret.link}?utm_medium=relacionadas_left&utm_source=cartacapital.com.br" title="${ret.title}" class="s-related__item">
                                 ${thumb}
                                 <div class="s-related__text">
                                    <h3>${number} ${ret.title}</h3>
                                    ${author}
                                 </div>
                              </a>`;

                    // Adicionar rel=prefetch no head
                    let linkElement = document.createElement("link");
                    linkElement.rel = "prefetch";
                    linkElement.href = ret.link;
                    document.head.appendChild(linkElement);

                    x++;
                });

                $(".ssopopular--single").prepend(htmlmaislidos);

                if (window.innerWidth < 800) {
                    $(".ssopopular--single .s-related__item").each(function () {
                        let medium = $(this).attr("href");
                        medium = medium.replace(
                            "relacionadas_left",
                            "leiamais_inread"
                        );
                        $(this).attr("href", medium);
                    });
                }

                // se o parametro mais-lidas existir
                if (window.location.href.indexOf("mais-lidas") > -1) {
                    if (window.innerWidth < 800) {
                    }
                } else {
                    if (
                        window.innerWidth < 800 &&
                        $(".s-also__container .post").length == 0
                    ) {
                        $(
                            ".s-content__grid--first .s-content__right .s-related"
                        ).removeClass("desktop-only");
                        $(
                            ".s-content__grid--first .s-content__right .s-related"
                        ).insertAfter(
                            ".s-content__grid--second + .banner.mobile-only"
                        );
                    }
                }
            }
        })
        .catch((error) => console.log("error", error));
    return false;
}
//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

/**Envia um comentário
 * @param token
 * @param slug
 */

function ssoCommentSend() {
    let thisUrl = window.location.pathname.split("/");
    let filtered = thisUrl.filter(Boolean);
    let slug = filtered[filtered.length - 1];

    $("body").append(htmlloading);
    let requestOptions = {
        method: "PUT",
        headers: ssoHeaders,
        body: JSON.stringify({
            comment_content: document.querySelector('[name="comment"]').value,
        }),
    };

    fetch(
        urlsso +
            "/readers/" +
            getCookie("sso_auth_token") +
            "/posts/" +
            slug +
            "/comments",
        requestOptions
    )
        .then((response) => response.json())
        .then((data) => {
            ssoComments();
            document.querySelector('[name="comment"]').value = "";
        })
        .catch((error) => console.log("error", error));
    return false;
}

/**Retorna comentarios do post
 * @param token
 * @param slug
 */

function ssoComments() {
    let thisUrl = window.location.pathname.split("/");
    let filtered = thisUrl.filter(Boolean);
    let slug = filtered[filtered.length - 1];
    $(".listacomments").remove();
    let requestOptions = {
        method: "GET",
        headers: ssoHeaders,
    };
    fetch(urlsso + "/posts/" + slug + "/comments", requestOptions)
        .then((response) => response.json())
        .then((data) => {
            console.log(data);
            if (data.length > 0) {
                let commentsCounter = 0;
                var htmlcomments =
                    '<section class="e-comments listacomments">\
                        <h2>' + data.length + " comentário" + (data.length > 1 ? "s" : "") + "</h2>";

                var commentAnswers = [];
                data.forEach(function (ret) {
                    let date = new Date(ret.comment_date);

                    let formattedDate = date.toLocaleDateString('pt-BR', {
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric',
                    });

                    let formattedTime = date.toLocaleTimeString('pt-BR', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: false
                    }).replace(':', 'h');

                    let datacomment = `${formattedDate} ${formattedTime}`;

                    if (ret.comment_parent != "0") {
                        commentAnswers.push(ret);
                    } else {
                        htmlcomments +=
                            "<article data-comment-id=" + ret.comment_ID +'>\
                                <span class="author">' +
                                    ret.comment_author.split(" ")[0] +
                                '</span>\
                                <span class="date">' +
                                    datacomment +
                                '</span>\
                                <div class="comment-content">' +
                                    ret.comment_content +
                                "</div>\
                            </article>";

                        commentsCounter++;
                    }
                });

                if (commentsCounter > 3) {
                    htmlcomments +=
                        '<button" class="js-loadmore-comments">Ler mais comentários</button>';
                }
                htmlcomments += "</section>";

                let commentsInitial = 4;

                if ( $('.c-comments').length ) {
                    $(htmlcomments).insertBefore(".c-comments");
                } else {
                    $(htmlcomments).insertAfter(".loadcoments");
                }

                if (commentAnswers.length > 0) {
                    commentAnswers.forEach(function (ret) {
                        let commentParent = $(
                            "[data-comment-id=" + ret.comment_parent + "]"
                        );

                        if (commentParent) {
                            let date = new Date(ret.comment_date);
        
                            let formattedDate = date.toLocaleDateString('pt-BR', {
                                day: '2-digit',
                                month: 'long',
                                year: 'numeric',
                            });
        
                            let formattedTime = date.toLocaleTimeString('pt-BR', {
                                hour: '2-digit',
                                minute: '2-digit',
                                hour12: false
                            }).replace(':', 'h');
        
                            let datacomment = `${formattedDate} ${formattedTime}`;

                            commentParent.append(
                                "<article data-comment-id=" +
                                    ret.comment_ID +
                                    '>\
                                             <span class="author">' +
                                    ret.comment_author +
                                    '</span>\
                                             <span class="date">' +
                                    datacomment +
                                    '</span>\
                                             <div class="comment-content">' +
                                    ret.comment_content +
                                    "</div>\
                                          </article>"
                            );
                        }
                    });
                }

                if (commentsCounter > 3) {
                    console.log(
                        $(
                            `.listacomments > article:nth-of-type(n + ${commentsInitial})`
                        )
                    );
                    $(
                        `.listacomments > article:nth-of-type(n + ${commentsInitial})`
                    ).hide();

                    $(".js-loadmore-comments").click(function () {
                        commentsInitial += 3;
                        $(`.listacomments > article`).show();
                        $(
                            `.listacomments > article:nth-of-type(n + ${commentsInitial})`
                        ).hide();

                        if (
                            $(".listacomments > article:last-of-type").is(
                                ":visible"
                            )
                        ) {
                            $(this).hide();
                        }
                    });
                }
            }
            $(".loading").fadeOut();
        })
        .catch((error) => console.log("error", error));

    return false;
}

//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

/**Fluxo de salvar favorito / bookmarks
 * @param token
 * @param slug
 */

// $('.s-content__bookmark').on('click', function () {
//    console.log("save bookmark")
//    ssoSaveBookmark();
// });

function ssoSaveBookmark() {
    $("body").append(htmlloading);

    if ($(".s-content__bookmark--bookmarked").length > 0) {
        if ($(".savebookmark").data("bookmark-id") !== undefined) {
            let requestOptions = {
                method: "DELETE",
                headers: ssoHeaders,
                redirect: "follow",
            };
            fetch(
                urlsso +
                    "/readers/" +
                    getCookie("sso_auth_token") +
                    "/bookmarks/" +
                    $(".savebookmark").data("bookmark-id"),
                requestOptions
            )
                .then((response) => response.json())
                .then((data) => {
                    $(".loading").fadeOut();
                    $(".savebookmark").removeClass(
                        "s-content__bookmark--bookmarked"
                    );
                    //document.location.reload(true);
                })
                .catch((error) => console.log("error", error));
        }
    } else {
        let requestOptions = {
            method: "POST",
            headers: ssoHeaders,
            body: JSON.stringify({
                title: $(".savebookmark").data("title"),
                url: window.location.pathname,
                post_id: $(".savebookmark").data("id"),
                category: $(".savebookmark").data("category"),
                image: $(".savebookmark").data("image"),
                excerpt: $(".savebookmark").data("excerpt"),
                data_hour: $(".savebookmark").data("data_hour"),
                author: $(".savebookmark").data("author"),
            }),
            redirect: "follow",
        };
        fetch(
            urlsso + "/readers/" + getCookie("sso_auth_token") + "/bookmarks",
            requestOptions
        )
            .then((res) => {
                data = res.json();

                //Caso ja exista ele executa comando para excluir
                if (res.status == 409) {
                    $(".loading").fadeOut();
                }

                if (res.status == 200) {
                    $(".loading").fadeOut();
                    $(".savebookmark").addClass(
                        "s-content__bookmark--bookmarked"
                    );
                }

                if (res.status == 201) {
                    $(".loading").fadeOut();
                    $(".savebookmark").addClass(
                        "s-content__bookmark--bookmarked"
                    );
                }
                return data;
            })
            .then((data) => {
                //document.location.reload(true);
                console.log(data.bookmark_id);
                $(".savebookmark").data("bookmark-id", data.bookmark_id);
                $(".loading").fadeOut();
            })
            .catch((error) => console.log("error", error));
    }
    return false;
}

function ssoConsultBookmark() {
    let requestOptions = {
        method: "GET",
        headers: ssoHeaders,
        redirect: "follow",
    };

    fetch(
        urlsso +
            "/readers/" +
            getCookie("sso_auth_token") +
            "/bookmarks?url=" +
            window.location.pathname,
        requestOptions
    )
        .then((response) => response.json())
        .then((data) => {
            if (data.status == true) {
                $(".savebookmark").addClass("s-content__bookmark--bookmarked");
                $(".savebookmark").attr("data-bookmark-id", data.bookmark_id);
            }
        })
        .catch((error) => console.log("error", error));
    return false;
}
// <p>Lembre-se, o que seu plano é o <strong>Básico</strong> portanto você possui um <strong>limite de 20 matérias</strong> para salvar.</p>\
function ssoGetBookmark() {
    let requestOptions = {
        method: "GET",
        headers: ssoHeaders,
    };
    fetch(
        urlsso + "/readers/" + getCookie("sso_auth_token") + "/bookmarks",
        requestOptions
    )
        .then((response) => response.json())
        .then((data) => {
            if (data.length > 0) {
                let htmlreturn = "";
                data.forEach(function (ret) {
                    let htmlImage =
                        ret.image != undefined
                            ? `<figure class="l-list__image">
                                    <img src="${ret.image}" alt="${ret.title}">
                                 </figure>`
                            : "";
                    let htmlCategory =
                        ret.category != undefined
                            ? `<h3>${ret.category}</h3>`
                            : "";
                    let htmlExcerpt =
                        ret.excerpt != undefined ? `<p>${ret.excerpt}</p>` : "";
                    let htmlAuthor =
                        ret.author != undefined
                            ? `Por <strong>${ret.author}</strong>`
                            : "";
                    let htmlData =
                        ret.data_hour != undefined ? ` | ${ret.data_hour}` : "";

                    htmlreturn += `<a href="${ret.url}" title="${ret.title}" class="l-list__item">
                              ${htmlImage}
                              <div class="l-list__text">
                                 ${htmlCategory}
                                 <h2>${ret.title}</h2>
                                 ${htmlExcerpt}
                                 <span>${htmlAuthor}${htmlData}</span>
                              </div>
                           </a>`;
                });

                $(htmlreturn).appendTo(".m-salvos");
            }
        })
        .catch((error) => console.log("error", error));
    return false;
}

//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
/***
 * Fluxo cadastro de email em newsletters
 * news diaria
 */
function ssoNoUserNews(newsType = "news_diaria", el) {
    let isvalid = $(".newsform." + newsType).valid();
    if (isvalid) {
        $("body").append(htmlloading);
        let requestOptions = {
            method: "POST",
            headers: ssoHeaders,
            body: JSON.stringify({
                email: el.parentElement.querySelector('input').value,
                newsletter: newsType,
            }),
        };

        fetch(urlsso + "/regristrations/newsletters", requestOptions)
            .then((res) => {
                data = res.json();

                return data;
            })
            .then((data) => {
                document.querySelector('[name="email"]').value = "";
                $(".loading .msg").html('<i class="none"></i>' + data.message);
                setTimeout(() => {
                    $(".loading").fadeOut();
                }, 1500);
            })
            .catch((error) => console.log("error", error));

        setTimeout(() => {
            if ($(".loading").is(":visible")) {
                $(".loading .msg").html(
                    '<i class="none"></i> Erro interno no servidor. Tente novamente mais tarde.'
                );
                setTimeout(() => {
                    $(".loading").fadeOut();
                }, 1500);
            }
        }, 10000);
    }
    return false;
}
function ssoNoUserNewsSquare() {
    let isvalid = $(".newsformSquare").valid();
    if (isvalid) {
        $("body").append(htmlloading);
        let requestOptions = {
            method: "POST",
            headers: ssoHeaders,
            body: JSON.stringify({
                email: $(".newsformSquare").find('input[name="email"]').val(),
            }),
        };

        fetch(urlsso + "/regristrations/newsletters", requestOptions)
            .then((res) => {
                data = res.json();

                return data;
            })
            .then((data) => {
                document.querySelector('[name="email"]').value = "";
                $(".loading .msg").html('<i class="none"></i>' + data.message);
                setTimeout(() => {
                    $(".loading").fadeOut();
                }, 1500);
            })
            .catch((error) => console.log("error", error));

        setTimeout(() => {
            if ($(".loading").is(":visible")) {
                $(".loading .msg").html(
                    '<i class="none"></i> Erro interno no servidor. Tente novamente mais tarde.'
                );
                setTimeout(() => {
                    $(".loading").fadeOut();
                }, 1500);
            }
        }, 10000);
    }
    return false;
}

/***
 * Check if user exists in RD Station and validate if user is subscriber
 * Then, modify the HTML accordingly
 */
function validateRdStationUser(subscriber, rdExists) {
    let isSubscriber = subscriber;
    let rdUserExists = rdExists;

    if ( isSubscriber && rdUserExists ) {
        document.querySelectorAll('.verify-redstation').forEach( el => {
            el.closest('section').style.display = 'none';
        })
    }

    if ( !isSubscriber && rdUserExists ) {
        // hide forms
        // show message to subscribe
    }
}

//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
/***
 * Fluxo de newsletters para usuários logados
 */
function ssoListNewsletters() {
    let thisUrl = window.location.pathname.split("/");
    let filtered = thisUrl.filter(Boolean);
    let slug = filtered[filtered.length - 1];

    if ( document.querySelector("body").getElementsByClassName("locked").length > 0 && slugPage == "minha-conta" ) {
        setTimeout(() => {
            $("body").addClass("hide");
        }, 200);
        setTimeout(() => {
            let requestOptions = {
                method: "GET",
                headers: ssoHeaders,
            };
            fetch(
                urlsso +
                    "/readers/" +
                    getCookie("sso_auth_token") +
                    "/newsletters/access",
                requestOptions
            )
                .then((response) => response.json())
                .then((data) => {
                    if (data.length > 0) {
                        var htmlNewsletter = "";
                        data.forEach(function (ret) {
                            console.log(
                                ret.for_subscriber +
                                    " == " +
                                    getCookie("ssoassinante")
                            );
                            htmlNewsletter +=
                                '<label for="' +
                                ret.tag +
                                '" class="a-newsletter__item ' +
                                (ret.for_subscriber == true &&
                                getCookie("ssoassinante") == "false"
                                    ? "disabled"
                                    : "") +
                                '">\
                                 <input type="checkbox" name="subjects[]" id="' +
                                ret.tag +
                                '" value="' +
                                ret.newsletter_id +
                                '" ' +
                                (ret.status == true ? 'checked=""' : "") +
                                " " +
                                (ret.for_subscriber == true &&
                                getCookie("ssoassinante") == "false"
                                    ? 'disabled="" readonly'
                                    : "") +
                                '>\
                                 <figure class="a-newsletter__figure">\
                                    <img src="' +
                                ret.url_image +
                                '" alt="' +
                                ret.title +
                                '">\
                                 </figure>\
                                 <div class="a-newsletter__text">\
                                    <h2>' +
                                ret.title +
                                "</h2>\
                                    <h3>" +
                                (ret.for_subscriber == true
                                    ? '<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="https://www.w3.org/2000/svg">\
                                    <path d="M6 8.5V9.75V8.5ZM2.25 12.25H9.75C10.0815 12.25 10.3995 12.1183 10.6339 11.8839C10.8683 11.6495 11 11.3315 11 11V7.25C11 6.91848 10.8683 6.60054 10.6339 6.36612C10.3995 6.1317 10.0815 6 9.75 6H2.25C1.91848 6 1.60054 6.1317 1.36612 6.36612C1.1317 6.60054 1 6.91848 1 7.25V11C1 11.3315 1.1317 11.6495 1.36612 11.8839C1.60054 12.1183 1.91848 12.25 2.25 12.25ZM8.5 6V3.5C8.5 2.83696 8.23661 2.20107 7.76777 1.73223C7.29893 1.26339 6.66304 1 6 1C5.33696 1 4.70107 1.26339 4.23223 1.73223C3.76339 2.20107 3.5 2.83696 3.5 3.5V6H8.5Z" stroke="#0B0B0B" stroke-linecap="round" stroke-linejoin="round"></path>\
                                 </svg> Exclusiva para assinantes.'
                                    : "Livre para todos.") +
                                "</h3>\
                                    <p>" +
                                ret.description +
                                "</p>\
                                    <span>" +
                                (ret.status == true
                                    ? "Ja é inscrito"
                                    : "Quero cadastrar") +
                                "</span>\
                                 </div>\
                              </label>";
                        });
                        htmlNewsletter +=
                            '<input type="submit" value="Atualizar" onclick="ssoSaveNewsletter()">';

                        $(".retNewsletter").html(htmlNewsletter);
                    }
                    $("body").removeClass("hide");
                })
                .catch((error) => console.log("error", error));
        }, 500);
    }
}

function ssoSaveNewsletter() {
    let subjects = $(".retNewsletter").serializeArray();
    let newsletters = Array();
    subjects.forEach(function (ret) {
        newsletters.push(parseInt(ret.value));
    });
    setTimeout(() => {
        $("body").append(htmlloading);
        let requestOptions = {
            method: "PUT",
            headers: ssoHeaders,
            body: JSON.stringify({
                news_letters: newsletters,
            }),
        };
        fetch(
            urlsso +
                "/readers/" +
                getCookie("sso_auth_token") +
                "/subscriptions",
            requestOptions
        )
            .then((res) => {
                data = res.json();
                if (res.status == 200) {
                    setTimeout(() => {
                        window.location.href = "/minha-conta";
                    }, 2000);
                } else {
                    setTimeout(() => {
                        $(".loading").fadeOut();
                    }, 2000);
                }

                return data;
            })
            .then((data) => {
                $(".loading .msg").html('<i class="none"></i>' + data.message);
            })
            .catch((error) => console.log("error", error));
    }, 300);
    return false;
}

/***
 * Fluxo de newsletters que o usuário assinante
 */
function ssoListUserNewsletters() {
    let requestOptions = {
        method: "GET",
        headers: ssoHeaders,
    };
    fetch(
        urlsso + "/readers/" + getCookie("sso_auth_token") + "/subscriptions",
        requestOptions
    )
        .then((response) => response.json())
        .then((data) => {
            if (data.length > 0) {
                var htmlNewsletter =
                    '<div class="a-account__box a-saved">\
                                    <h2>Newsletters</h2>\
                                    <div class="a-saved__box">\
                                       <span>Confira as newsletter que você assina:</span>';
                data.forEach(function (ret) {
                    htmlNewsletter +=
                        "<article>\
                                          <h2>" +
                        ret.title +
                        '</h2> <a href="/minha-conta#newsletter">Cancelar</a>\
                                       </article>';
                });
                htmlNewsletter +=
                    '</div>\
                                 <a href="/minha-conta#newsletter">Ver mais newsletters</a>\
                              </div>';

                $(htmlNewsletter).insertBefore(".a-pref");
            }
            $("body").removeClass("hide");
        })
        .catch((error) => console.log("error", error));
}

//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
/***
 * Fluxo de newsletters para usuários deslogados
 */
function ssoListNewslettersNoUser() {
    $("body").append(htmlloading);
    let params = new URLSearchParams(window.location.search);
    if (params.has("token") == true) {
        let requestOptions = {
            method: "GET",
            headers: ssoHeaders,
        };
        fetch(
            urlsso + "/unsubscribe/" + params.get("token") + "/newsletters",
            requestOptions
        )
            .then((res) => {
                data = res.json();
                if (res.status == 404) {
                    $(".loading .msg").html(
                        '<i class="none"></i>Token expirado!'
                    );
                    setTimeout(() => {
                        window.location.href = "/descadastrar";
                    }, 1000);
                }
                return data;
            })
            .then((data) => {
                if (data.length > 0) {
                    var htmlNewsletter = "";
                    data.forEach(function (ret) {
                        htmlNewsletter +=
                            '<label for="' +
                            ret.tag +
                            '" class="a-newsletter__item">\
                                    <input type="checkbox" name="subjects[]" id="' +
                            ret.tag +
                            '" value="' +
                            ret.tag_legado +
                            '" ' +
                            (ret.status == true ? 'checked=""' : "") +
                            '>\
                                    <figure class="a-newsletter__figure">\
                                       <img src="' +
                            ret.url_image +
                            '" alt="' +
                            ret.title +
                            '">\
                                    </figure>\
                                    <div class="a-newsletter__text">\
                                       <h2>' +
                            ret.title +
                            "</h2>\
                                       <h3>" +
                            (ret.for_subscriber == true
                                ? "Exclusiva para assinantes."
                                : "Livre para todos.") +
                            "</h3>\
                                       <p>" +
                            ret.description +
                            "</p>\
                                       <span>" +
                            (ret.status == true
                                ? "Ja é inscrito"
                                : "Quero cadastrar") +
                            "</span>\
                                    </div>\
                                 </label>";
                    });
                    htmlNewsletter +=
                        '<input type="submit" value="Cadastrar" onclick="ssoSaveNewsletterNoUser()">';

                    $(".retNewsletterOpen").html(htmlNewsletter);
                    $(".loading").fadeOut();
                }
            })
            .catch((error) => console.log("error", error));
    } else {
        window.location.href = "/descadastrar";
    }
}

function ssoSaveNewsletterNoUser() {
    let params = new URLSearchParams(window.location.search);
    let subjects = $(".retNewsletterOpen").serializeArray();
    let newsletters = Array();
    subjects.forEach(function (ret) {
        newsletters.push(ret.value);
    });
    setTimeout(() => {
        $("body").append(htmlloading);
        let requestOptions = {
            method: "POST",
            headers: ssoHeaders,
            body: JSON.stringify({
                news_letters: newsletters,
            }),
        };
        fetch(
            urlsso + "/unsubscribe/" + params.get("token") + "/newsletters",
            requestOptions
        )
            .then((res) => {
                data = res.json();
                if (res.status == 200) {
                    setTimeout(() => {
                        window.location.href = "/";
                    }, 2000);
                } else {
                    setTimeout(() => {
                        $(".loading").fadeOut();
                    }, 2000);
                }

                return data;
            })
            .then((data) => {
                $(".loading .msg").html('<i class="none"></i>' + data.message);
            })
            .catch((error) => console.log("error", error));
    }, 300);
    return false;
}

function ssoListNewslettersOpen() {
    $("body").append(htmlloading);

    let requestOptions = {
        method: "GET",
        headers: ssoHeaders,
    };
    fetch(urlsso + "/newsletters", requestOptions)
        .then((res) => {
            data = res.json();
            if (res.status == 404) {
                setTimeout(() => {
                    window.location.href = "/newsletters-abertas";
                }, 1000);
            }
            return data;
        })
        .then((data) => {
            if (data.length > 0) {
                var htmlNewsletter = "";
                data.forEach(function (ret) {
                    htmlNewsletter +=
                        '<label for="' +
                        ret.tag_nouser +
                        '" class="a-newsletter__item ' +
                        (ret.for_subscriber == true ? "disabled" : "") +
                        '">\
                                 <input type="checkbox" name="subjects[]" id="' +
                        ret.tag_nouser +
                        '" value="' +
                        ret.tag_nouser +
                        '" ' +
                        (ret.for_subscriber == true
                            ? 'disabled="" readonly'
                            : "") +
                        '>\
                                 <figure class="a-newsletter__figure">\
                                    <img src="' +
                        ret.url_image +
                        '" alt="' +
                        ret.title +
                        '">\
                                 </figure>\
                                 <div class="a-newsletter__text">\
                                    <h2>' +
                        ret.title +
                        "</h2>\
                                    <h3>" +
                        (ret.for_subscriber == true
                            ? '<svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="https://www.w3.org/2000/svg">\
                                    <path d="M6 8.5V9.75V8.5ZM2.25 12.25H9.75C10.0815 12.25 10.3995 12.1183 10.6339 11.8839C10.8683 11.6495 11 11.3315 11 11V7.25C11 6.91848 10.8683 6.60054 10.6339 6.36612C10.3995 6.1317 10.0815 6 9.75 6H2.25C1.91848 6 1.60054 6.1317 1.36612 6.36612C1.1317 6.60054 1 6.91848 1 7.25V11C1 11.3315 1.1317 11.6495 1.36612 11.8839C1.60054 12.1183 1.91848 12.25 2.25 12.25ZM8.5 6V3.5C8.5 2.83696 8.23661 2.20107 7.76777 1.73223C7.29893 1.26339 6.66304 1 6 1C5.33696 1 4.70107 1.26339 4.23223 1.73223C3.76339 2.20107 3.5 2.83696 3.5 3.5V6H8.5Z" stroke="#0B0B0B" stroke-linecap="round" stroke-linejoin="round"></path>\
                                 </svg> Exclusiva para assinantes.'
                            : "Livre para todos.") +
                        "</h3>\
                                    <p>" +
                        ret.description +
                        "</p>\
                                    <span>" +
                        (ret.status == true
                            ? "Ja é inscrito"
                            : "Quero cadastrar") +
                        "</span>\
                                 </div>\
                              </label>";
                });
                htmlNewsletter +=
                    '<div class="h-newsletter__form">\
                                    <input type="text" name="email" placeholder="Seu e-mail">\
                                    <button type="submit" onclick="ssoSaveNewsletterOpen();">Cadastrar</button>\
                                 </div>';
                //             <label for="email">\
                //                      <input type="email" name="email" id="email" placeholder="ex. nome@email.com.br">\
                //                   </label>'
                // htmlNewsletter += '<input type="submit" value="Cadastrar" onclick="ssoSaveNewsletterOpen()">'

                $(".retNewsOpen").html(htmlNewsletter);
                $(".loading").fadeOut();
            }
        })
        .catch((error) => console.log("error", error));
}

function ssoSaveNewsletterOpen() {
    let isvalid = $(".retNewsOpen").valid();
    if (isvalid) {
        $("body").append(htmlloading);
        let subjects = $(".retNewsOpen").serializeArray();
        let newsletters = Array();
        subjects.forEach(function (ret) {
            if (ret.name != "email") {
                newsletters.push(ret.value);
            }
        });
        if (newsletters.length > 0) {
            let requestOptions = {
                method: "POST",
                headers: ssoHeaders,
                body: JSON.stringify({
                    email: document.querySelector('[name="email"]').value,
                    news_letters: newsletters,
                }),
            };

            fetch(urlsso + "/contacts/registration/newsletters", requestOptions)
                .then((response) => response.json())
                .then((data) => {
                    document.querySelector('[name="email"]').value = "";
                    $(".loading .msg").html(
                        '<i class="none"></i>' + data.message
                    );
                    setTimeout(() => {
                        $(".loading").fadeOut();
                    }, 1500);
                })
                .catch((error) => console.log("error", error));
        } else {
            $(".loading .msg").html(
                '<i class="none"></i>Nenhuma lista selecionada'
            );
            setTimeout(() => {
                $(".loading").fadeOut();
            }, 800);
        }
    }
    return false;
}

function ssoUnsubscribe() {
    let isvalid = $(".ssounsubscribe").valid();
    if (isvalid) {
        $("body").append(htmlloading);
        let requestOptions = {
            method: "POST",
            headers: ssoHeaders,
            body: JSON.stringify({
                email: document.querySelector('[name="email"]').value,
            }),
        };
        fetch(urlsso + "/unsubscribe/", requestOptions)
            .then((response) => response.json())
            .then((data) => {
                if (data.registered == true) {
                    if (getCookie("sso_auth_token") !== null) {
                        window.location.href = "/minha-conta#newsletter";
                    } else {
                        window.location.href = "/acesso";
                    }
                } else {
                    if (data.token !== undefined) {
                        window.location.href =
                            "/descadastrar/lista?token=" + data.token;
                    } else {
                        $(".loading .msg").html(
                            '<i class="none"></i>' + data.message
                        );
                        setTimeout(() => {
                            $(".loading").fadeOut();
                        }, 2000);
                    }
                }
                console.log(data);
            })
            .catch((error) => console.log("error", error));
    }
    return false;
}

/*** IMPLEMENTAÇÃO GRAVAÇÃO DADOS ELASTIC SEARCH */
function ssoElastic() {
    let dateSend = new Date(new Date());
    var slkHeaders = new Headers();
    slkHeaders.append("Content-Type", "application/json");
    let requestOptions = {
        method: "POST",
        headers: slkHeaders,
        body: JSON.stringify({
            category: document.querySelector('[name="category"]').value,
            paywall:
                document.querySelector('[name="paywall"]').value == 1
                    ? "true"
                    : "false",
            title: document.querySelector('[name="title"]').value,
            slug: window.location.pathname,
            post_id: parseInt(document.querySelector('[name="post_id"]').value),
            reader_id: parseInt(getCookie("sso_reader")),
            product: getCookie("sso_product"),
            token: getCookie("sso_auth_token"),
            datetime: dateSend
                .toISOString()
                .split("-")
                .join("/")
                .split("T")
                .join(" ")
                .slice(0, 19),
            origin: "single",
        }),
        redirect: "follow",
    };
    fetch("https://track.cartacapital.com.br/track", requestOptions)
        .then((response) => {
            console.log(response);
        })
        .then((result) => {
            console.log(
                "%c RETORNOU DADOS",
                "color: white; background-color: blue"
            );
            console.log(result);
        })
        .catch((error) =>
            console.log("%c" + error, "color: white; background-color: red")
        );
}

function ssoElasticLogin() {
    let dateSend = new Date(new Date());
    var slkHeaders = new Headers();
    slkHeaders.append("Content-Type", "application/json");
    let requestOptions = {
        method: "POST",
        headers: slkHeaders,
        body: JSON.stringify({
            reader_id: parseInt(getCookie("sso_reader")),
            product: getCookie("sso_product"),
            datetime: dateSend
                .toISOString()
                .split("-")
                .join("/")
                .split("T")
                .join(" ")
                .slice(0, 19),
            origin: "login",
        }),
        redirect: "follow",
    };
    fetch("https://track.cartacapital.com.br/track", requestOptions)
        .then((response) => {
            console.log(response);
        })
        .then((result) => {
            console.log(
                "%c RETORNOU DADOS",
                "color: white; background-color: blue"
            );
            console.log(result);
        })
        .catch((error) =>
            console.log("%c" + error, "color: white; background-color: red")
        );
}
/*** IMPLEMENTAÇÃO GRAVAÇÃO DADOS ELASTIC SEARCH */

function ssoLoginGoogle(data, tag = "cc-cadastrado-google") {
    $("body").append(htmlloading);

    // add source, medium and content to body if contains 'homolog' in url
    let source = "",
        medium = "",
        content = "";

    if (getCookie("ssotype") == "soft") {
        let params = new URLSearchParams(window.location.search);

        source = params.get("utm_source");
        medium = params.get("utm_medium");
        content = params.get("utm_content");

        if (source != null && medium != null && content != null) {
            (source = source), (medium = medium), (content = content);
        }
    }

    let requestOptions = {
        method: "POST",
        headers: ssoHeaders,
        body: JSON.stringify({
            name: data.name,
            email: data.email,
            googleId: data.sub,
            source: source,
            medium: medium,
            content: content,
            tag: tag
        }),
    };

    fetch(urlsso + "/readers/auth/google", requestOptions)
        .then((res) => {
            data = res.json();
            if (res.status == 500) {
                $(".loading .msg").html(
                    '<i class="none"></i>Erro concluir a solicitação. Tente novamente em alguns minutos'
                );
                setTimeout(() => {
                    $(".loading").fadeOut();
                }, 1500);
            }

            if (res.status == 401) {
                $(".loading .msg").html('<i class="none"></i>' + data.message);
                setTimeout(() => {
                    window.location.href = "/minha-conta/confirmar-e-mail/";
                }, 1500);
            }
            return data;
        })
        .then((data) => {
            if (typeof data.token !== "undefined") {
                document.cookie = "sso_origin=google; expires=" + date.toUTCString() + "; path=/; domain=." + domainName;
                document.cookie = "sso_auth_token=" + data.token + "; expires=" + date.toUTCString() + "; path=/; domain=." + domainName;
                document.cookie = "ssoassinante=" + data.subscriber + "; expires=" + date.toUTCString() + "; path=/; domain=." + domainName;
                document.cookie = "sso_reader=" + data.reader_id + "; expires=" + date.toUTCString() + "; path=/; domain=." + domainName;
                document.cookie = "sso_product=" + data.product + "; expires=" + date.toUTCString() + "; path=/; domain=." + domainName;
                userData();
            } else {
                $(".loading .msg").html('<i class="none"></i>' + data.message);
                setTimeout(() => {
                    $(".loading").fadeOut();
                }, 1500);
            }
        })
        .catch((error) => console.log("error", error));
    return false;
}

function userLoginApple(data) {
    //  console.log("Chamou o userLoginApple")
    $("body").append(htmlloading);

    // add source, medium and content to body if contains 'homolog' in url
    let source = "",
        medium = "",
        content = "";

    if (getCookie("ssotype") == "soft") {
        let params = new URLSearchParams(window.location.search);

        source = params.get("utm_source");
        medium = params.get("utm_medium");
        content = params.get("utm_content");

        if (source != null && medium != null && content != null) {
            (source = source), (medium = medium), (content = content);
        }
    }

    let name = null;
    let email = null;
    if (data.user) {
        name = `${data.user.name.firstName} ${data.user.name.lastName}`;
        email = data.user.email;
    }
    let requestOptions = {
        method: "POST",
        headers: ssoHeaders,
        body: JSON.stringify({
            email: email,
            codigo: data.authorization.id_token,
            type_login: "APPLE",
            name: name,
            source: source,
            medium: medium,
            content: content,
        }),
    };
    const urlssov2 = urlsso.replace("v1", "v2");
    fetch(urlssov2 + "/readers/authentication", requestOptions)
        .then((res) => {
            data = res.json();
            if (res.status == 502) {
                $(".loading .msg").html(
                    '<i class="none"></i>Falha na comunicação. Tente novamente.'
                );
                setTimeout(() => {
                    $(".loading").fadeOut();
                }, 1500);
            }

            if (res.status == 500) {
                $(".loading .msg").html(
                    '<i class="none"></i>Erro ao concluir a solicitação. Tente novamente em alguns minutos'
                );
                setTimeout(() => {
                    $(".loading").fadeOut();
                }, 1500);
            }

            if (res.status == 403) {
                $(".loading .msg").html('<i class="none"></i>' + data.message);
                setTimeout(() => {
                    $(".loading").fadeOut();
                }, 1500);
            }

            if (res.status == 401) {
                $(".loading .msg").html(
                    '<i class="none"></i> Verifique seu e-mail e senha e tente novamente.'
                );
                setTimeout(() => {
                    $(".loading").fadeOut();
                }, 1500);
            }
            return data;
        })
        .then((data) => {
            if (typeof data.token !== "undefined") {
                console.log(data);
                document.cookie =
                    "sso_auth_token=" +
                    data.token +
                    "; expires=" +
                    date.toUTCString() +
                    "; path=/; domain=." +
                    domainName;
                document.cookie =
                    "ssoassinante=" +
                    data.subscriber +
                    "; expires=" +
                    date.toUTCString() +
                    "; path=/; domain=." +
                    domainName;
                document.cookie =
                    "sso_reader=" +
                    data.reader_id +
                    "; expires=" +
                    date.toUTCString() +
                    "; path=/; domain=." +
                    domainName;
                document.cookie =
                    "sso_product=" +
                    data.product +
                    "; expires=" +
                    date.toUTCString() +
                    "; path=/; domain=." +
                    domainName;
                userData();
            } else {
                $(".loading .msg").html('<i class="none"></i>' + data.message);
                setTimeout(() => {
                    $(".loading").fadeOut();
                }, 1500);
            }
        })
        .catch((error) => console.log("error", error));

    return false;
}

function linkPresenteSingle() {
    const html = `<a href="#" 
                     title="Compartilhar o Link" 
                     onclick="gtag('event', 'social share', {\n'event_category': NTG social - link-presente, \n'event_label': window.location.href, \n'non_interaction': false\n})"
                     class="s-content__share--link share-link">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: #cd1719;transform: scale(1);msFilter:;"><path d="M5 12H4v8a2 2 0 0 0 2 2h5V12H5zm13 0h-5v10h5a2 2 0 0 0 2-2v-8h-2zm.791-5A4.92 4.92 0 0 0 19 5.5C19 3.57 17.43 2 15.5 2c-1.622 0-2.705 1.482-3.404 3.085C11.407 3.57 10.269 2 8.5 2 6.57 2 5 3.57 5 5.5c0 .596.079 1.089.209 1.5H2v4h9V9h2v2h9V7h-3.209zM7 5.5C7 4.673 7.673 4 8.5 4c.888 0 1.714 1.525 2.198 3H8c-.374 0-1 0-1-1.5zM15.5 4c.827 0 1.5.673 1.5 1.5C17 7 16.374 7 16 7h-2.477c.51-1.576 1.251-3 1.977-3z"></path></svg>
                  </a>`;

    const htmlHeader = `<a href="#" 
                           title="Compartilhar o Link" 
                           onclick="gtag('event', 'social share', {\n'event_category': NTG social - link-presente, \n'event_label': window.location.href, \n'non_interaction': false\n})"
                           class="info__share--link share-link">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: #fff;transform: scale(1.2);msFilter:;"><path d="M5 12H4v8a2 2 0 0 0 2 2h5V12H5zm13 0h-5v10h5a2 2 0 0 0 2-2v-8h-2zm.791-5A4.92 4.92 0 0 0 19 5.5C19 3.57 17.43 2 15.5 2c-1.622 0-2.705 1.482-3.404 3.085C11.407 3.57 10.269 2 8.5 2 6.57 2 5 3.57 5 5.5c0 .596.079 1.089.209 1.5H2v4h9V9h2v2h9V7h-3.209zM7 5.5C7 4.673 7.673 4 8.5 4c.888 0 1.714 1.525 2.198 3H8c-.374 0-1 0-1-1.5zM15.5 4c.827 0 1.5.673 1.5 1.5C17 7 16.374 7 16 7h-2.477c.51-1.576 1.251-3 1.977-3z"></path></svg>
                        </a>`;

    const htmlNoteLink = `<section class="s-link">
                     <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: #cd1719;transform: scale(0.8);vertical-align: middle;"><path d="M5 12H4v8a2 2 0 0 0 2 2h5V12H5zm13 0h-5v10h5a2 2 0 0 0 2-2v-8h-2zm.791-5A4.92 4.92 0 0 0 19 5.5C19 3.57 17.43 2 15.5 2c-1.622 0-2.705 1.482-3.404 3.085C11.407 3.57 10.269 2 8.5 2 6.57 2 5 3.57 5 5.5c0 .596.079 1.089.209 1.5H2v4h9V9h2v2h9V7h-3.209zM7 5.5C7 4.673 7.673 4 8.5 4c.888 0 1.714 1.525 2.198 3H8c-.374 0-1 0-1-1.5zM15.5 4c.827 0 1.5.673 1.5 1.5C17 7 16.374 7 16 7h-2.477c.51-1.576 1.251-3 1.977-3z"></path></svg>
                        <strong>Link Presente:</strong>
                        Gostou deste texto? Assinantes podem liberar cinco acessos gratuitos a qualquer conteúdo por mês!
                     </span>
                  </section>`;

    $(".s-tags").after(htmlNoteLink);
    $(".s-content__share").prepend(html);
    $(".info .info__share span").after(htmlHeader);

    $(".share-link").click((ev) => {
        ev.preventDefault();

        clipboardToLink();
    });

    $(".s-link").click((ev) => {
        ev.preventDefault();

        clipboardToLink();
    });
}

function clipboardToLink() {
    $("body").append(htmlloading);

    const url = window.location.href;

    let pathUrl = window.location.pathname.split("/");
    let filtered = pathUrl.filter(Boolean);
    let slug = filtered[filtered.length - 1];

    const data = {
        url,
        slug,
        imagem: document.querySelector('[name="imagem_thumb"]').value,
        category: document.querySelector('[name="category"]').value,
        excerpt: document.querySelector('[name="excerpt"]').value,
        author: document.querySelector('[name="autores"]').value,
        dataPostagem: document.querySelector('[name="data_hour"]').value,
    };

    let requestOptions = {
        method: "POST",
        headers: ssoHeaders,
        body: JSON.stringify(data),
    };

    const urlssov2 = urlsso.replace("v1", "v2");
    fetch(
        urlssov2 + "/link-presentes/readers/" + getCookie("sso_auth_token"),
        requestOptions
    )
        .then((res) => res.json())
        .then((res) => {
            if (res.message) {
                $(".loading .msg").html('<i class="">' + res.message + "</i>");
                setTimeout(() => {
                    $(".loading").fadeOut();
                }, 1500);
            }

            if (!res.message) {
                const link = `${res["link"]}&utm_source=cartacapital.com.br&utm_medium=linkpresente&utm_content=${slug}`;

                navigator.clipboard.writeText(link).then(() => {
                    $(".loading .msg").html(
                        '<i class=""></i>Link copiado para área de transferência!'
                    );
                    setTimeout(() => {
                        $(".loading").fadeOut();
                    }, 1500);
                });

                setTimeout(() => {
                    window.open(
                        `https://api.whatsapp.com/send?text=Link-presente: um assinante de CartaCapital te oferece uma leitura grátis do artigo abaixo. \n ${link}`,
                        "_blank"
                    );
                }, 1500);
            }
        })
        .catch((error) => console.log(error));
}

function ssoGetLinkPresente() {
    let requestOptions = {
        method: "GET",
        headers: ssoHeaders,
    };

    const urlssov2 = urlsso.replace("v1", "v2");
    fetch(
        urlssov2 + "/link-presentes/readers/" + getCookie("sso_auth_token"),
        requestOptions
    )
        .then((response) => response.json())
        .then((data) => {
            if (data.linksPermanentes.length > 0) {
                let htmlreturn = "";
                data.linksPermanentes.forEach(function (ret) {
                    if (ret.page) {
                        let htmlImage =
                            ret.imagem != "Sem imagem"
                                ? `<figure class="l-list__image">
                              <img src="${ret.imagem}" alt="${ret.page.title}">
                           </figure>`
                                : "";
                        let htmlCategory =
                            ret.category != undefined
                                ? `<h3>${ret.category}</h3>`
                                : "";
                        let htmlExcerpt =
                            ret.excerpt != undefined
                                ? `<p>${ret.excerpt}</p>`
                                : "";
                        let htmlAuthor =
                            ret.author != undefined
                                ? `Por <strong>${ret.author}</strong>`
                                : "";
                        let htmlData =
                            ret.dataPostagem != undefined
                                ? ` | ${ret.dataPostagem}`
                                : "";

                        const url =
                            window.location.protocol +
                            "//" +
                            window.location.host;

                        htmlreturn += `<a href="${url}/teste/${ret.page.slug}" title="${ret.page.title}" class="l-list__item">
                        ${htmlImage}
                        <div class="l-list__text">
                           ${htmlCategory}
                           <h2>${ret.page.title}</h2>
                           ${htmlExcerpt}
                           <span>${htmlAuthor}${htmlData}</span>
                        </div>
                     </a>`;
                    }
                });

                $(htmlreturn).appendTo(".m-links");
            }
        })
        .catch((error) => console.log("error", error));
    return false;
}

function modalLinkPresente() {
    $("body").append(htmlloading);
    const htmlModal = `<div class="modal-presente__window">
                        <h2>Link Presente</h2>
                        <p>Achamos que a informação deve ser acessível. Os 'links-presente' são uma maneira de democratizar o acesso ao nosso conteúdo. Se você acredita no valor do jornalismo e na construção de um novo Brasil, junte-se a nós!</p>
                        
                        <form action="" id="form" class="newsform link_presente" onsubmit="formSubmit(); return false;">
                           <input type="text" placeholder="Digite seu e-mail" name="email"/>
                           <button type="submit" onclick="ssoNoUserNews('link_presente')">Enviar</button>
                           <button type="button" class="modal-presente__close">Continuar Lendo</button>
                        </form>
                     </div>`;

    $("body").css({
        overflow: "hidden",
    });

    $(".loading").html(htmlModal);

    $('.modal-presente__close, .link_presente button[type="submit"]').on("click", function (ev) {
        ev.preventDefault();

        if (this.type === "submit") {
            setTimeout(() => {
                $(".loading").fadeOut();
                $("body").css({
                    overflow: "visible",
                });
            }, 1500);
        } else {
            $(".loading").fadeOut();
            $("body").css({
                overflow: "visible",
            });
        }
    });
}
